import { infiniteQueryOptions } from '@tanstack/react-query';
import { GetAdjustersListQueryParamsType } from './getAdjustersListQuery.type';
import { getAdjustersListFunction } from './getAdjustersListQueryFunction';
import { getNextPage } from '@/modules/FileList/utils/getNextPage';

export const getAdjustersListQueryOptions = (
  params: GetAdjustersListQueryParamsType,
) => {
  return infiniteQueryOptions({
    queryKey: ['AdjusterList', params],
    queryFn: ({ pageParam }) =>
      getAdjustersListFunction({
        ...params,
        page: pageParam as number,
        page_size: 10,
      }),
    initialPageParam: 1,
    getNextPageParam: getNextPage,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  });
};
